<template>
  <div>
    <h2 class="text-center">Tax Calculation</h2>
    <div class="auth-container">
      <div class="auth-card">
        <h2 class="text-center">Create an Account</h2>

        <!-- Error Message -->
        <div v-if="errorMessage" class="alert alert-danger text-center">
          {{ errorMessage }}
        </div>

        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label class="form-label">User Name</label>
            <input type="text" class="form-control" v-model="username" placeholder="User Name" @input="clearErrors"
              required />
          </div>
          <div class="mb-3">
            <label class="form-label">Email Address</label>
            <input type="email" class="form-control" v-model="email" placeholder="Email" @input="clearErrors"
              required />
            <small v-if="emailerro" class="text-danger"> {{ emailerro }} </small>
          </div>
          <div class="mb-3">
            <label class="form-label">Password</label>
            <input type="password" class="form-control" v-model="password" placeholder="Password"
              @input="validatePassword" required />
            <small v-if="passwordError" class="text-danger">{{ passwordError }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">Confirm Password</label>
            <input type="password" class="form-control" v-model="confirm_password" placeholder="Confirm Password"
              @input="validateConfirmPassword" required />
            <small v-if="confirmPasswordError" class="text-danger">{{
              confirmPasswordError
            }}</small>
          </div>
          <button type="submit" class="btn btn-primary w-100 mt-3">Sign up</button>
          <div v-if="loading" class="loader-overlay">
            <div class="loader"></div>
          </div>
        </form>
        <p class="text-center mt-3">
          Already have an account?
          <router-link to="/" class="text-decoration-none">Login</router-link>
        </p>
      </div>
    </div>

    <!-- Success Modal -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content text-center p-4">
          <div class="modal-body">
            <i class="bi bi-check-circle-fill text-success" style="font-size: 50px"></i>
            <h4 class="text-success mt-3">Success!</h4>
            <p>{{ successMessage }}</p>
            <button class="btn btn-success mt-3" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { registerUser } from "../End Points/api";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
export default {
  data() {
    return {
      username: "",
      email: "",
      password: "",
      confirm_password: "",
      successMessage: "",
      errorMessage: "",
      passwordError: "",
      confirmPasswordError: "",
      loading: false,
      emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|in|edu|gov|info|biz|co)(\.[a-z]{2})?$/i,
      emailerro: "",
    };
  },
  methods: {
    validatePassword() {
      const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#?!@$%^&*-]).{8,}$/;

      if (!passwordRegex.test(this.password)) {
        this.passwordError =
          "Password must be at least 8 characters long, contain one uppercase, one lowercase, one number, and one special character.";
      } else {
        this.passwordError = "";
      }

      this.validateConfirmPassword();
    },

    validateConfirmPassword() {
      if (this.confirm_password && this.password !== this.confirm_password) {
        this.confirmPasswordError = "Passwords do not match!";
      } else {
        this.confirmPasswordError = "";
      }
    },
    clearErrors() {
      this.errorMessage = "";
    },

    async submitForm() {
      this.successMessage = "";
      this.errorMessage = "";
      this.emailerro = "";
      this.validatePassword();
      this.validateConfirmPassword();
      if (!this.emailRegex.test(this.email)) {
        this.emailerro = "invalid email formate";
        return;
      }
      if (this.passwordError || this.confirmPasswordError) {
        return;
      }
      this.loading = true;
      try {
        const userdata = {
          username: this.username,
          email: this.email,
          password: this.password,
          confirm_password: this.confirm_password,
        };

        console.log("Sending request to API:", userdata);
        const response = await registerUser(userdata);
        if (!response) {
          this.loading = true;
        }
        console.log("Success Response:", response.data);
        this.successMessage = "Signup successful! Waiting for admin approval.";
        this.showSuccessModal();

        this.username = "";
        this.email = "";
        this.password = "";
        this.confirm_password = "";
        this.errorMessage = "";
      } catch (error) {
  console.error("Signup failed:", error);

  if (error.response) {
    console.log("Error Response Data:", error.response.data);
    this.errorMessage = error.response.data.message || "Signup failed!"; 
    if (error.response.data.message.username)
    {
      this.errorMessage = error.response.data.message.username[0];
   }
          if (error.response.data.message.includes("Username already exists.")) {
      this.errorMessage = "Username is already taken. Please choose another.";
    }

    if (error.response.data.message.includes("Email already exists")) {
      this.errorMessage = "Email is already registered. Please use another.";
    }
  } else if (error.request) {
    this.errorMessage = "No response from server. Try again later.";
  } else {
    this.errorMessage = "An unexpected error occurred.";
  }
      } finally {
        this.loading = false;
      }
    },

    showSuccessModal() {
      const modal = new bootstrap.Modal(document.getElementById("successModal"));
      modal.show();
    },
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to right, #667eea, #764ba2);
  padding: 20px;
}

.auth-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.alert {
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.btn-primary {
  background: #764ba2;
  border: none;
  transition: 0.3s;
}

.btn-primary:hover {
  background: #5b2a86;
}

@media (max-width: 768px) {
  .auth-card {
    padding: 20px;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
